<button mat-button class="fast-filter" matTooltip="Filtre por {{ name }}" [matMenuTriggerFor]="menu"
  *ngIf="!range.start || !range.end">
  <span *ngIf="!range.start && !range.end">Filtrar por data</span>
  <span *ngIf="range.start || range.end">{{ name }}</span>
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>

<mat-menu #menu="matMenu" class="calendar">
  <mat-calendar (selectedChange)="dateSelected($event)" (click)="$event.stopPropagation()"></mat-calendar>
</mat-menu>

<mat-chip *ngIf="range.start && range.end" (removed)="clearSelectedRange()">
  <div class="flex items-center gap-2">
    <mat-icon>check</mat-icon>
    {{ range.start | date : "dd, MMMM, yyyy" }} -
    {{ range.end | date : "dd, MMMM, yyyy" }}
  </div>
  <mat-icon matChipRemove matTooltip="Remover {{ name }}: {{
      range.start | date : 'dd, MMMM, yyyy'
    }} - {{ range.end | date : 'dd, MMMM, yyyy' }}">cancel</mat-icon>
</mat-chip>